module.exports = __webpack_public_path__ + "static/poster2-bf9779ee00949363b8621aa2be39cf2c.png";